export enum FavoriteRegions {
  Moscow = 1,
  SPB = 2,
  MO = 4593,
  LO = 4588,
}

export interface IRegion {
  id: number;
  displayName: string;
  mainTownId?: number | null;
  regionId?: number | null;
}

export interface IRegionsViewModel {
  favorites?: IRegion[];
  alphabet?: Regions[];
}

export const MOSCOW_MO = 'Москва и МО';
export const SPB_LO = 'Санкт-Петербург и ЛО';

export type Regions = [string, IRegion[]];

export class SeparatorProps {
  public columnsCount = 4;
  public relTitleHeight = 2.5;

  public constructor(columnsCount?: number) {
    if (columnsCount !== undefined && columnsCount !== 0) {
      this.columnsCount = columnsCount;
    }
  }
}

export function separateByColumns(array: Regions[], props: SeparatorProps): [Regions[]] {
  const totalHeight = calcTotalHeight(array, props.relTitleHeight);

  const targetHeight = totalHeight / props.columnsCount;
  let bucketHeight = 0;

  return array.reduce((buckets: Regions[][], group: Regions) => {
    if (!buckets.length) {
      buckets.push([] as Regions[]);
    }

    let currBucket = buckets[buckets.length - 1];
    const nextGroupHeight = group[1].length + props.relTitleHeight;

    if (currBucket.length === 0) {
      currBucket.push(group);
      bucketHeight += nextGroupHeight;

      return buckets;
    }

    const futureHeight = bucketHeight + nextGroupHeight;

    if (targetHeight - futureHeight > 0) {
      currBucket.push(group);
      bucketHeight += nextGroupHeight;

      return buckets;
    }

    if (buckets.length === props.columnsCount - 1) {
      currBucket.push(group);
      buckets.push([] as Regions[]);
      bucketHeight = 0;

      return buckets;
    }

    if (buckets.length === props.columnsCount) {
      currBucket.push(group);
      bucketHeight = nextGroupHeight;

      return buckets;
    }

    if ((targetHeight - futureHeight) * -1 >= targetHeight - bucketHeight) {
      buckets.push([] as Regions[]);
      currBucket = buckets[buckets.length - 1];
      currBucket.push(group);
      bucketHeight = nextGroupHeight;
    } else {
      currBucket = buckets[buckets.length - 1];
      currBucket.push(group);
      buckets.push([] as Regions[]);
      bucketHeight = 0;
    }

    return buckets;
    // tslint:disable-next-line:no-any
  }, [] as any);
}

function calcTotalHeight(alphabet: Regions[], relTitleHeight: number): number {
  return alphabet.reduce((sum: number, group: Regions) => sum + relTitleHeight + group[1].length, 0);
}

export function convertToViewModel(regions: IRegion[], shouldSkip: boolean): IRegionsViewModel {
  const viewModel = regions
    //удаляем регионы для которых нет данных
    .filter(
      (region: IRegion) => (shouldSkip && region.id !== FavoriteRegions.MO && region.id !== FavoriteRegions.LO) || true,
    )
    //переименовываем избранные регионы
    .map((region: IRegion) => {
      if (shouldSkip) {
        return region;
      }

      switch (region.id) {
        case FavoriteRegions.Moscow:
          region.displayName = MOSCOW_MO;
          break;
        case FavoriteRegions.SPB:
          region.displayName = SPB_LO;
          break;
        default:
          break;
      }

      return region;
    })
    //сортируем регионы в алфавитном порядке
    .sort((previosRegion: IRegion, nextRegion: IRegion) => {
      if (previosRegion.displayName === nextRegion.displayName) {
        return 0;
      }

      return previosRegion.displayName > nextRegion.displayName ? 1 : -1;
    })
    //разбиваем массив на структуру и двух: 1ый список избранных, 2ой регионы в алфавитном порядке
    .reduce(
      (prev: [IRegion[], IRegion[]], currentValue: IRegion) => {
        if (!shouldSkip && (currentValue.id === FavoriteRegions.Moscow || currentValue.id === FavoriteRegions.SPB)) {
          prev[0].push(currentValue);

          return prev;
        }

        prev[1].push(currentValue);

        return prev;
      },
      [[], []] as [IRegion[], IRegion[]],
    )
    //собираем новую коллекцию
    .reduce(
      (previousValue: IRegionsViewModel, currentValue: IRegion[], index: number) => {
        if (index === 0) {
          previousValue.favorites = currentValue;
        } else {
          previousValue.alphabet = devideListToAlphabet(currentValue);
        }

        return previousValue;
      },
      {
        alphabet: [] as Regions[],
        favorites: [] as IRegion[],
      },
    );

  return viewModel || regions;
}

function devideListToAlphabet(regions: IRegion[]) {
  return regions.reduce((previousValue: Regions[], currentValue: IRegion) => {
    const regionIndex = currentValue.displayName[0];

    if (previousValue.length === 0) {
      previousValue.push([regionIndex, [currentValue] as IRegion[]]);

      return previousValue;
    }

    const currentAlphabetIndex = previousValue[previousValue.length - 1][0];

    if (currentAlphabetIndex === regionIndex) {
      previousValue[previousValue.length - 1][1].push(currentValue);
    } else {
      previousValue.push([regionIndex, [currentValue] as IRegion[]]);
    }

    return previousValue;
  }, [] as Regions[]);
}
